import React from "react"
import { Layout } from "antd"
import styles from "./index.module.css"
import { Outlet } from "react-router-dom"
import { ResourcesBreadcrumb } from "./BreadCrumb"
import classNames from "classnames"

export const ProResourcesLayout = () => {
  return (
    <Layout className={classNames(styles.layout)}>
      <ResourcesBreadcrumb />
      <Outlet />
    </Layout>
  )
}
